<template>
  <div>
    <Header></Header>
    <div v-if="user.sessionId && sessionId" id="myhome" class="myhome-main site-main main-content">
      <router-view :show-modal-error="showModalError" @display-menu="showMenu = true"></router-view>
    </div>
    <dea-footer variant="socialfaqprefooter" source="formazione" skin="deascuola"></dea-footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import asyncConfig from "@/components/mixins/asyncConfig";
import staticAutosuggestData from "@/components/mixins/staticAutosuggestData";
import Header from "~/components/shared/Header";

export default {
  name: "MyHomeApp",
  components: { Header },
  mixins: [asyncConfig, staticAutosuggestData],
  data() {
    document.title = "Area Personale";
    return {
      returnUrl: "",
      orderId: null,
      showModalError: false,
      showMenu: false,
      sessionId: null,
    };
  },
  computed: {
    ...mapGetters(["user", "config", "order"]),
  },
  watch: {
    // call again the method if the route changes
    $route: "updateRegistrations",
  },
  created() {
    window.headerApp = this;
    try {
      this.$root.data.config = this.config;
    } catch {
      this.$root.data = { config: this.config };
    }
    const urlParams = new URLSearchParams(window.location.search);
    this.orderId = urlParams.get("order_id");
  },
  mounted() {
    document.querySelector("dea-top-header").addEventListener("update-user", this.updateSessionIdAndUser);

    const returnCookie = this.$cookies.get("formazioneReturnUrl");
    if (returnCookie) this.returnUrl = returnCookie;
    else this.returnUrl = this.config.public_url;

    this.$nextTick(async () => {
      await this.updateSessionIdAndUser();
    });
  },
  destroyed() {
    document.querySelector("dea-top-header").removeEventListener("update-user", this.updateSessionIdAndUser);
  },
  methods: {
    ...mapActions(["fetchOrder", "confirmData", "fetchRegistrations", "fetchCartOrder"]),
    async updateRegistrations() {
      if (this.$route.params.updateRegistrations && !this.user.student && !this.user.parent) {
        await this.fetchRegistrations();
      }
    },
    async updateSessionIdAndUser() {
      const localSessionId = window.localStorage.getItem("sessionId");
      const user = JSON.parse(window.localStorage.getItem("profile"));

      if (localSessionId) {
        this.sessionId = localSessionId;
        await this.updateRegistrations();
      }

      if (user) {
        this.$store.commit("setUser", user);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_local-variables"; //sass-lint:disable-line clean-import-paths

.myhome-main {
  min-height: 100vh;
}

.main-container {
  padding-bottom: 120px;
}
</style>
